import { useEffect } from 'react';

/**
 * Custom hook for smooth scrolling behavior
 * Replaces jQuery smooth scrolling functionality
 *
 * Intercepts clicks on elements with .smoothscroll class
 * and scrolls to the target element smoothly
 *
 * @example
 * function App() {
 *   useSmoothScroll();
 *   return <div>...</div>;
 * }
 */
export const useSmoothScroll = () => {
  useEffect(() => {
    // Enable smooth scrolling behavior
    document.documentElement.style.scrollBehavior = 'smooth';

    const handleClick = (e) => {
      const target = e.target.closest('.smoothscroll');
      if (target) {
        e.preventDefault();
        const href = target.getAttribute('href');

        if (href && href.startsWith('#')) {
          const id = href.substring(1);
          const element = document.getElementById(id);

          if (element) {
            element.scrollIntoView({
              behavior: 'smooth',
              block: 'start'
            });

            // Update URL hash without jumping
            window.history.pushState(null, null, href);
          }
        }
      }
    };

    document.addEventListener('click', handleClick);

    return () => {
      document.removeEventListener('click', handleClick);
      document.documentElement.style.scrollBehavior = 'auto';
    };
  }, []);
};
